import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { FieldWrapperModule } from '../../modules-shared/field-wrapper/field-wrapper.module';
import { SharedModule } from '../../modules-shared/shared.module';
import { FormPage } from './form';
import { FormSlidePickerComponent } from './form-slide-picker.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        IonicPageModule.forChild(FormPage),
        TranslateModule.forChild(),
        FieldWrapperModule
    ],
    declarations: [
        FormPage,
        FormSlidePickerComponent
    ],
    exports: [
        FormPage
    ],
    entryComponents: [
        FormPage,
        FormSlidePickerComponent
    ]
})
export class FormPageModule {
}



// WEBPACK FOOTER //
// ./src/vas/pages/form/form.module.ts